import React, { useEffect, useState } from 'react';
import MDEditor from '@uiw/react-md-editor';
import styles from './NewFeaturesAdmin.module.css';
import {
  collection, query, orderBy, getDocs, addDoc,
  deleteDoc, updateDoc, doc, onSnapshot
} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import LightNav from "./../LightNav/LightNav";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { Navigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import Button from '../../ui/Button';

export default function NewFeaturesAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({
    title: '', description: '', details: '',
    imageUrl: '', link: '', order: 1, file: null
  });
  const { notify } = useNotifications();
  const { user, userData, claims } = useAuth(); 
  const { t } = useTranslation(); 
  /*useEffect(() => {
    async function fetch() {
      const q = query(collection(firestore, 'newFeatures'), orderBy('order'));
      const snap = await getDocs(q);
      setItems(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    }
    fetch();
  }, []);*/
  
  
  useEffect(() => {
		const q = query(collection(firestore, "newFeatures"), orderBy("order"));

		const unsubscribe = onSnapshot(q, (snapshot) => {
		  setItems(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
		});

		return () => unsubscribe();
  }, []);//user, userData]);

  const uploadImage = async (file) => {
    const fileRef = ref(storage, `newFeatures/${Date.now()}_${file.name}`);
    const snap = await uploadBytes(fileRef, file);
    return await getDownloadURL(snap.ref);
  };

  const handleAdd = async () => {
    try {
      let imageUrl = form.imageUrl;
      if (form.file) imageUrl = await uploadImage(form.file);
      await addDoc(collection(firestore, 'newFeatures'), {
        ...form,
        imageUrl,
        order: parseInt(form.order, 10),
        file: null
      });
      notify('success', 'Feature added!');
      setForm({
        title: '', description: '', details: '',
        imageUrl: '', link: '', order: 1, file: null
      });
    } catch (err) {
      notify('error', err.message);
    }
  };

  const handleUpdate = async (id, field, value, isFile = false) => {
    try {
      let updateData = {};
      if (field === 'file' && value) {
        const url = await uploadImage(value);
        updateData['imageUrl'] = url;
      } else {
        updateData[field] = field === 'order' ? parseInt(value, 10) : value;
      }
      await updateDoc(doc(firestore, 'newFeatures', id), updateData);
      //notify('success', 'Updated!');
    } catch (err) {
      notify('error', err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(firestore, 'newFeatures', id));
      notify('success', 'Deleted');
    } catch (err) {
      notify('error', err.message);
    }
  };
  
  if (!user || claims?.role !== 'admin') {
    return <Navigate to="/home" />;
  }

  return (
	<>
    <LightNav/>
    <div className={styles.container}>
      <h2>{t('admin.newFeaturesTitle')}</h2>
      <div className={styles.form}>
        <input value={form.title} placeholder="Title"
          onChange={e => setForm(f => ({ ...f, title: e.target.value }))} />
        <input value={form.description} placeholder="Short Description"
          onChange={e => setForm(f => ({ ...f, description: e.target.value }))} />
        <MDEditor
          value={form.details} height={500}
          onChange={val => setForm(f => ({ ...f, details: val }))}
          textareaProps={{ placeholder: "Full feature description (Markdown)" }}
        />
        <input type="file"
          onChange={e => setForm(f => ({ ...f, file: e.target.files[0] }))} />
        <input value={form.link} placeholder="Optional Link"
          onChange={e => setForm(f => ({ ...f, link: e.target.value }))} />
        <input value={form.order} type="number" placeholder="Order"
          onChange={e => setForm(f => ({ ...f, order: e.target.value }))} />
        <Button variant="primary" onClick={handleAdd}>{t('admin.addFeature')}</Button>
      </div>

        {items.map(item => (
          <div key={item.id}>
		  <h2>{item.id}</h2>
            <input
              value={item.title}
              onChange={e => handleUpdate(item.id, 'title', e.target.value)}
            />
            <input
              value={item.description}
              onChange={e => handleUpdate(item.id, 'description', e.target.value)}
            />
            <MDEditor height={400}
              value={item.details || ''}
              onChange={val => handleUpdate(item.id, 'details', val)}
              textareaProps={{ placeholder: 'Edit full details (Markdown)' }}
            />
            <div className={styles.flexRow}>
              <input type="file"
                onChange={e => handleUpdate(item.id, 'file', e.target.files[0], true)} />
              {item.imageUrl && <img src={item.imageUrl} alt="" className={styles.thumb} />}
            </div>
            <input
              value={item.link || ''}
              onChange={e => handleUpdate(item.id, 'link', e.target.value)}
            />
            <input
              value={item.order}
              type="number"
              onChange={e => handleUpdate(item.id, 'order', e.target.value)}
            />
            <Button variant="secondary" onClick={() => handleDelete(item.id)}>{t('admin.delete')}</Button>
          </div>
        ))}

    </div>
	</>
  );
}

